
























import { onMounted, reactive, toRefs } from '@vue/composition-api';
import kdSelectionBox from '@k/components/kdSelectionBox/Index.vue';
import { SELECTION_BOX_POP_TYPE } from '@k/components/constants/business';
import { isiOS, inApp } from '@w/utils/system';
import { isShip } from '@kd/env';
import { isFullFunctionality } from '@/constants/version'
import { APP_NAME } from '@/constants';

export default {
  name: 'kdzy',
  components: {
    kdSelectionBox,
  },
  setup(props: any, { root }: any) {
    const data = reactive({
      selectionList: [
        {
          title: '用户服务协议',
          popType: SELECTION_BOX_POP_TYPE.PAGE_JUMP,
          entry: 'services',
        },
        {
          title: '用户隐私政策摘要',
          popType: SELECTION_BOX_POP_TYPE.PAGE_JUMP,
          entry:
            'https://gth5.kuaiduizuoye.com/perform/privacy/kd-privacy-brief',
        },
        {
          title: '用户隐私政策',
          popType: SELECTION_BOX_POP_TYPE.PAGE_JUMP,
          entry: 'https://gth5.kuaiduizuoye.com/perform/privacy/kd-privacy',
        },
        {
          title: '儿童用户隐私政策',
          popType: SELECTION_BOX_POP_TYPE.PAGE_JUMP,
          entry: 'children',
        },
        {
          title: '隐私权限设置',
          popType: SELECTION_BOX_POP_TYPE.PAGE_JUMP,
          entry: 'permissionPage',
          isJumpAction: true,
          isHide: isiOS,
        },
        {
          title: '资质证照公示',
          popType: SELECTION_BOX_POP_TYPE.PAGE_JUMP,
          entry: 'license',
        },
      ],
    });
    Number(root.$cmn.vc) >= 635 &&
      /huawei/i.test(root.$cmn.brand) &&
      data.selectionList.push({
        title: '通过应用市场更新',
        popType: SELECTION_BOX_POP_TYPE.PAGE_JUMP,
        entry: 'hms_check_update',
        isJumpAction: true,
        isHide: isiOS || !isFullFunctionality,
      });
    onMounted(() => {
      root.hybrid('modifyTitleText', { title: `关于${APP_NAME}` });
    });

    const pageJump = (entry: string, isJumpAction = false) => {
      // 跳转 action
      if (isJumpAction) {
        root.hybrid(entry);
        return;
      }

      // 保证协议不走离线化，让用户看到最新更改
      const noCacheMap = ['services', 'privacy', 'children', 'license'];

      // 测试环境无法使用线上链接
      const mainUrl = isShip
        ? `${location.origin}/static/hy/app-vue/about.html#/`
        : 'https://www.kuaiduizuoye.com/static/hy/app-vue/about.html#/';

      if (noCacheMap.indexOf(entry) !== -1) {
        inApp
          ? root.hybrid('core_openWindow', {
              pageUrl: mainUrl + entry,
            })
          : (location.href = mainUrl + entry);

        return;
      }

      // 链接直接跳转
      if (/^https?:/.test(entry)) {
        root.hybrid('core_openWindow', {
          pageUrl: entry,
        });

        return;
      }

      root.route({ name: entry });
    };

    /**
     * 跳转到工信部网站
     */
    const jumpToInfo = () => {
      root.hybrid('core_openBrowser', {
        url: 'https://beian.miit.gov.cn',
      });
    };

    return {
      ...toRefs(data),
      pageJump,
      jumpToInfo,
    };
  },
};
